var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49,
    height: 52,
    viewBox: "0 0 49 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_625",
    "data-name": "Group 625",
    transform: "translate(-598 -1031)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_596",
    "data-name": "Rectangle 596",
    width: 49,
    height: 52,
    transform: "translate(598 1031)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "sent",
    transform: "translate(574.225 1039.525)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_287",
    "data-name": "Group 287",
    transform: "translate(33.057)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_286",
    "data-name": "Group 286"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M280.526.982a1.972,1.972,0,0,0-1.7-.982h-7.308V8.644h13.441Z",
    transform: "translate(-255.239 0)",
    fill: "#0bd19f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M57.3,0H49.919a1.971,1.971,0,0,0-1.7.984L43.8,8.644H57.3V0Z",
    transform: "translate(-43.068)",
    fill: "#0bd19f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M33.057,156.648V178.5a2.412,2.412,0,0,0,2.409,2.408H61.084a2.412,2.412,0,0,0,2.409-2.408V156.648Zm19.868,9.188-5.3,5.3a1.023,1.023,0,0,1-1.448,0L43.7,168.65a1.024,1.024,0,0,1,1.449-1.448l1.758,1.759,4.574-4.574a1.024,1.024,0,1,1,1.448,1.448Z",
    transform: "translate(-33.057 -145.955)",
    fill: "#0bd19f"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSent);
export default __webpack_public_path__ + "static/media/sent.02e396e0ccd2a9c683cf9eceabe060ce.svg";
export { ForwardRef as ReactComponent };